<form [formGroup]="form">
    <ion-list>
        <ion-item [disabled]="loading$ | async" [lines]="linesMode">
            <ion-label position="float">Current Client:</ion-label>
            <ion-spinner *ngIf="loading$ | async" class="ion-margin-start" name="circular"></ion-spinner>
            <ion-select [compareWith]="compareWith" [disabled]="disabled"
                [formControlName]="selectClientFormKeys.CLIENT" [interfaceOptions]="selectPopupOptions"
                [selectedText]="selectedClientText$ | async" interface="alert">
                <ion-select-option *ngFor="let client of clients$ | async" [value]="client">
                    {{ client.name }}
                </ion-select-option>
            </ion-select>
        </ion-item>
    </ion-list>
</form>